var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: { propsData: { isCountry: false, isDate: false } },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClick }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addCdtconversion.init()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              attrs: { "max-height": "600", data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: _vm.$t("idLabel"), width: "60" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "game_reveal",
                  label: _vm.$t("game"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "platform_reveal",
                  label: _vm.$t("platform"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "channel_reveal",
                  label: _vm.$t("channel"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pkg_reveal",
                  label: _vm.$t("pkg"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ad_channel_reveal",
                  label: _vm.$t("adChannel"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ad_placement_reveal",
                  label: _vm.$t("adPlacement"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "mark",
                  label: _vm.$t("newGuideLevelMark"),
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "mark_name",
                  label: _vm.$t("correspondingName"),
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operation"),
                  width: "160",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", { staticClass: "x-c" }, [
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.handleSource(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("modify")))]
                            ),
                            _c("div", { staticClass: "controlsBtn-vertical" }),
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.handleDelete(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2884086746
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.searchData.page,
              total: _vm.total,
              "page-size": 1
            },
            on: { "current-change": _vm.handleCurrentChange }
          })
        : _vm._e(),
      _c("new-guide", {
        ref: "addCdtconversion",
        on: { refreshDataList: _vm.searchClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }